import { render, staticRenderFns } from "./AAuditNameDisplay.vue?vue&type=template&id=56790f40&scoped=true&"
import script from "./AAuditNameDisplay.vue?vue&type=script&lang=ts&"
export * from "./AAuditNameDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./AAuditNameDisplay.vue?vue&type=style&index=0&id=56790f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56790f40",
  null
  
)

export default component.exports